import styled from 'styled-components';

import $Icon from 'components/Icon';

export const StarRating = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
`;

export const StarClickArea = styled.div`
  flex-grow: 1;
`;

export const StyledIcon = styled($Icon)`
  display: block;
  margin: auto;
  pointer-events: none; /* otherwise stars will flicker (as SVG hijacks the hover effect) */
`;
